/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import * as updateSystemAction from '@/actions/updateSystemAction';
import {Get, Post} from '@/api/request';
import {postCheckVersionUpdateSW} from '@/api/updateApi';
import {showSystemUpdateValidationModal} from '@/businesses/systemUpdateBusiness';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventCheckUpdateSystem} from '@/constants/pubSubEnum';
import {setSessionStorage, removeSessionStorage} from '@/libs/appHelper';
import {consoleLog, consoleError} from '@/libs/consoleHelper';
import {formatMessage} from '@/libs/intlHelper';
import {eventBusObject} from '@/observers/eventBus';

@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
  isMinimizeUpdate: store.updateSystemStore.IsMinimizeUpdate,
  isRestartLater: store.updateSystemStore.IsRestartLater,
  downloadBinaryUpdate: store.updateSystemStore.DownloadBinaryUpdate,
  downloadBinaryStatus: store.updateSystemStore.StatusDonloadBinaryUpdate,
  cancelDownloadBinary: store.updateSystemStore.CancelDownloadBinary,
  installSystemUpdate: store.updateSystemStore.InstallSystemUpdate,
  systemUpdateStatus: store.updateSystemStore.SystemUpdateStatus,
  checkSystemVersion: store.updateSystemStore.CheckVersionSystem,
  releaseNotes: store.updateSystemStore.ReleaseNotes,
}))
class UpdateSystem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      availabeUpdate: [],
      indexDownload: 0,
      // downloadLoadingText: '',
    };
    this._bus = eventBusObject();
    this._isDownloadUpdate = false;
    this._isDownloadComplate = false;
    this._isInstallingUpdate = false;
    this._isRequestDownloadingUpdate = false;
    this._isRequestCancle = false;
    this._isRequestInstallUpdate = false;
    this._checkUpdateData = undefined;
    this._isRequestCheckVersion = false;

    // this.errorPostInstallUpdate = this.errorPostInstallUpdate.bind(this);
    // this.failedPostInstallUpdate = this.failedPostInstallUpdate.bind(this);
    // this.successPostInstallUpdate = this.successPostInstallUpdate.bind(this);
    this.checkDownloadUpdateStatus = this.checkDownloadUpdateStatus.bind(this);
  }

  // tapScreenDownloadBinary = () => {
  //     var text = APPDATA.MESSAGES.SOFTWARE_UPDATE.STOP_DOWNLOAD_BINARY;
  //     var question = APPDATA.MESSAGES.SOFTWARE_UPDATE.STOP_DOWNLOAD_QUESTION;
  //     var buttonEvent = this.onClickTapDownloadBinary;
  //     this.tapLoadingScreen(text, question, buttonEvent);
  // };
  // eslint-disable-next-line react/sort-comp
  tapLoadingScreen = (text, question, onClickButton) => {
    const popUpButton = [
      {
        id: APPDATA.CONTINUE,
        isPrimaryButton: true,
        onClick: onClickButton,
        label: APPDATA.CONTINUE,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: onClickButton,
        label: APPDATA.CANCEL,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.UPDATE_SOFTWARE,
        popUpText: text,
        popUpQuestion: question,
        popUpButton,
      }),
    );
  };

  onClickDownloadLoadingButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.CANCEL:
        // this.tapScreenDownloadBinary;
        consoleLog('onClickDownloadLoadingButton Cancel', this._isDownloadUpdate);
        if (this._isDownloadUpdate) {
          this.cancelDownload();
          this._isRequestCancle = true;
          this.props.dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.DOWNLOAD_CANCEL,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO,
            }),
          );
        } else {
          this.props.dispatch(loadingActions.updateLoading({showLoading: false}));
          this._isRequestCancle = false;
        }
        break;
      case APPDATA.MINIMIZE:
        this.props.dispatch(updateSystemAction.isMinimizeUpdate(true));
        break;
      default:
        break;
    }
    this.props.dispatch(loadingActions.updateLoading({showLoading: false}));
  };

  componentDidMount() {
    this.eventDownloadUpdate = this._bus.subscribe(EventUpdateSystem.DownloadBinaryUpdate, (param) =>
      this.downloadUpdate(param),
    );
    this._checkUpdateData = setInterval(() => {
      if (this._isDownloadUpdate) {
        if (this._isDownloadComplate) {
          this.checkDownloadUpdateStatus(this.props.downloadBinaryStatus);
        } else {
          this.statusDownload();
        }
      }
      if (this._isInstallingUpdate) {
        this.checkInstallUpdateStatus();
      }
      if (this._isRequestDownloadingUpdate) {
        this.checkRequesDownloadUpdateSuccess();
      }
      if (this._isRequestCancle) {
        this.checkRequestCancleDownload();
      }
      if (this._isRequestInstallUpdate) {
        this.checkRequestInstallUpdate();
      }
      if (this._isRequestCheckVersion) {
        this.checkRequestSystemVersion();
      }
    }, 500);
  }

  componentWillUnmount() {
    this.eventDownloadUpdate.unsubscribe();
    clearTimeout(this._checkUpdateData);
  }

  // eslint-disable-next-line class-methods-use-this
  getUpdateId(updateName) {
    if (updateName.length === 0) return -1;
    for (let i = 0; i < updateName.length; i++) {
      if (updateName[i][APPDATA.KEY.Status] === APPDATA.ENUM.UPDATE_STATUS.UPDATING) return i;
    }
    return -1;
  }

  checkRequestSystemVersion = () => {
    if (this.props.checkSystemVersion) {
      this._isRequestCheckVersion = false;
      const response = {
        data: this.props.checkSystemVersion,
      };
      const availabeUpdate = [];
      // // software check
      // if (UpdateSystem.checkUpdateAvailable(response.data[APPDATA.ENUM.UPDATE_TYPE.SOFTWARE])) {
      //   availabeUpdate.push(APPDATA.ENUM.UPDATE_TYPE.SOFTWARE);
      // }
      // // firmware check
      // if (
      //   UpdateSystem.checkUpdateAvailable(response.data[APPDATA.ENUM.UPDATE_TYPE.FIRMWARE]) &&
      //   this.checkMinimumFWUpdate()
      // ) {
      //   availabeUpdate.push(APPDATA.ENUM.UPDATE_TYPE.FIRMWARE);
      // }
      // // os check
      // if (UpdateSystem.checkUpdateAvailable(response.data[APPDATA.ENUM.UPDATE_TYPE.OPERATING_SYSTEM])) {
      //   availabeUpdate.push(APPDATA.ENUM.UPDATE_TYPE.OPERATING_SYSTEM);
      // }
      if (response.data.IsUpdateAvailable) {
        availabeUpdate.push(APPDATA.ENUM.UPDATE_TYPE.SOFTWARE);
      }

      if (availabeUpdate.length > 0) {
        setSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM, availabeUpdate);
        const param = {
          UpdateType: availabeUpdate.toString(),
        };
        this.downloadUpdate(param);
        this._isRequestCheckVersion = false;
      } else {
        const popUpButton = [
          {
            id: APPDATA.OK,
            isPrimaryButton: true,
            onClick: this.onClickNoUpdate,
            label: APPDATA.OK,
          },
        ];
        this.props.dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.ONLINE_UPDATE,
            popUpText: APPDATA.MESSAGES.SOFTWARE_UPDATE.NO_NEW_VERSION,
            popUpButton,
          }),
        );
        this.props.dispatch(loadingActions.updateLoading({showLoading: false}));
      }
    }
  };

  retryCheckVersion = () => {
    this._isRequestCancle = true;
    this.props.dispatch(modalActions.hidePopUp());
    consoleLog('retryCheckVersion');
    this.cancelDownload();
    this.checkUpdateVersion();
  };

  onClickCanceledUpdate = () => {
    this._isRequestCancle = true;
    this.props.dispatch(modalActions.hidePopUp());
    consoleLog('onClickCanceledUpdate');
    this.cancelDownload();
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.DOWNLOAD_CANCEL,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO,
      }),
    );
  };

  onClickNoUpdate = () => {
    this.props.dispatch(modalActions.hidePopUp());
  };

  checkUpdateVersion() {
    removeSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM);
    this._bus.publish(EventCheckUpdateSystem.CheckingVersionUpdate, {});
  }

  // // eslint-disable-next-line react/sort-comp
  // static checkUpdateAvailable = (data) => {
  //   if (data[APPDATA.KEY.IsUpdateAvailable] === 'true') {
  //     return true;
  //   }
  //   return false;
  // };

  checkInstallUpdateStatus = () => {
    this.getStatusUpdate();
    if (this.props.systemUpdateStatus !== undefined) {
      const response = {
        data: this.props.systemUpdateStatus,
      };
      if (response.data[APPDATA.KEY.UpdateName].length === 0) {
        removeSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM);
        this._isInstallingUpdate = false;
        this.props.dispatch(loadingActions.updateLoading({showLoading: false}));
        // this.props.dispatch(
        //   setupActions.showAlert({
        //     alertShow: true,
        //     alertText: APPDATA.SUCCESS_UPDATE_AND_WAIT_FOR_RESTART,
        //     alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO,
        //   }),
        // );
        return;
      }
      const runningId = this.getUpdateId(response.data[APPDATA.KEY.UpdateName]);

      if (runningId === -1) {
        consoleError('UpdateName is Empty !');
        return;
      }
      // set loading status
      const updateOperations = response.data[APPDATA.KEY.UpdateName][runningId].UpdateOperations;
      const updatePercentage = response.data[APPDATA.KEY.UpdateName][runningId].ProgressUpdate;
      const updateAction = response.data[APPDATA.KEY.UpdateName][runningId].Action;
      this.props.dispatch(
        loadingActions.updateLoading({
          showLoading: true,
          loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.INSTALLING.replace(
            '{updateOperations}',
            updateOperations.toLowerCase().replace('_', ' '),
          )
            .replace('{updateAction}', updateAction)
            .replace('{updatePercentage}', updatePercentage),
          loadingClickEvent: undefined,
        }),
      );
    }
  };

  checkRequestInstallUpdate = () => {
    const {installSystemUpdate} = this.props;
    if (installSystemUpdate !== undefined) {
      this._isRequestInstallUpdate = false;
      this._isInstallingUpdate = true;
    }
  };

  checkRequestCancleDownload = () => {
    const {cancelDownloadBinary} = this.props;
    if (cancelDownloadBinary !== undefined) {
      this.props.dispatch(loadingActions.updateLoading({showLoading: false}));
      this._isRequestCancle = false;
    }
  };

  checkRequesDownloadUpdateSuccess = () => {
    const {downloadBinaryUpdate, downloadBinaryStatus} = this.props;
    if (downloadBinaryUpdate !== undefined && downloadBinaryStatus === undefined) {
      // const downloadLoadingText = APPDATA.MESSAGES.SOFTWARE_UPDATE.DOWNLOADING.replace('{...}', '0').replace(
      //   '{DownloadType}',
      //   this.state.availabeUpdate[this.state.indexDownload].toLowerCase().replace('_', ' '),
      // );
      // this.setState({
      //   downloadLoadingText,
      // });
      this._isDownloadUpdate = true;
      this._isDownloadComplate = false;
      this._isRequestDownloadingUpdate = false;
    }
  };

  checkDownloadUpdateStatus = (data) => {
    if (!data) {
      return;
    }
    if (data === undefined || data[APPDATA.KEY.Status] === undefined) {
      return;
    }
    if (this._isRequestCancle) {
      data[APPDATA.KEY.Status] = APPDATA.DownloadState.CANCELED;
    }
    switch (data[APPDATA.KEY.Status]) {
      case APPDATA.DownloadState.DOWNLOADING: {
        if (!this.props.isPCRunning && !this.props.isMinimizeUpdate && !this._isRequestCancle) {
          const percentageDownload = data[APPDATA.KEY.DownloadProgress];
          this.props.dispatch(
            loadingActions.updateLoading({
              showLoading: true,
              loadingText: formatMessage({id: 'loading.systemUpdate.downloading.message'}, {value: percentageDownload}), // this.state.downloadLoadingText.replace('0', percentageDownload),
              loadingButton1: {
                id: APPDATA.MINIMIZE,
                label: APPDATA.MINIMIZE,
                onClick: this.onClickDownloadLoadingButton,
              },
              loadingButton2: {
                id: APPDATA.CANCEL,
                label: APPDATA.CANCEL,
                onClick: this.onClickDownloadLoadingButton,
              },
              // loadingClickEvent: this.tapScreenDownloadBinary,
            }),
          );
        }
        break;
      }
      case APPDATA.DownloadState.CANCELED:
        this.props.dispatch(
          loadingActions.updateLoading({
            showLoading: false,
            loadingText: undefined,
            loadingClickEvent: undefined,
          }),
        );
        this._isDownloadUpdate = false;
        break;
      case APPDATA.DownloadState.TIMEOUT:
        this.props.dispatch(
          loadingActions.updateLoading({
            showLoading: false,
            loadingText: undefined,
            loadingClickEvent: undefined,
          }),
        );
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.TIME_OUT,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
          }),
        );

        this._isDownloadUpdate = false;
        this.props.dispatch(updateSystemAction.isMinimizeUpdate(false));
        break;
      case APPDATA.DownloadState.FAILED: {
        this._isDownloadUpdate = false;
        this.props.dispatch(
          loadingActions.updateLoading({
            showLoading: false,
            loadingText: undefined,
            loadingClickEvent: undefined,
          }),
        );

        this.props.dispatch(updateSystemAction.isMinimizeUpdate(false));
        const popUpButton = [
          {
            id: APPDATA.YES,
            isPrimaryButton: true,
            onClick: this.retryCheckVersion,
            label: APPDATA.YES,
          },
          {
            id: APPDATA.NO,
            isPrimaryButton: false,
            onClick: this.onClickCanceledUpdate,
            label: APPDATA.NO,
          },
        ];

        this.props.dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.ONLINE_UPDATE,
            popUpText: (
              <div>
                Download Error
                <br />
                Do you want to retry download?
              </div>
            ),
            popUpButton,
          }),
        );
        break;
      }
      case APPDATA.DownloadState.COMPLETE: {
        this._isDownloadComplate = true;
        if (!this.props.isPCRunning && !this.props.isMinimizeUpdate) {
          if (this.state.indexDownload === this.state.availabeUpdate.length - 1) {
            this._isDownloadUpdate = false;
            this.props.dispatch(loadingActions.updateLoading({showLoading: false}));
            this.props.dispatch(showSystemUpdateValidationModal());
            // this.needRestartModal();
            this._isRequestInstallUpdate = true;
          } else {
            // checkNextDownload
            let {indexDownload} = this.state;
            indexDownload += 1;
            this.props.dispatch(updateSystemAction.setSystemUpdatePending());
            const param = {
              [APPDATA.KEY.DownloadType]: this.state.availabeUpdate[indexDownload],
            };
            const passingVariabel = param;
            Post(
              APPDATA.API.DOWNLOAD_UPDATE,
              param,
              (response, passingVariabel) => {
                this.props.dispatch(updateSystemAction.setDownloadBinaryUpdate(response.data));
                consoleLog('Success Download Update', response, passingVariabel);
              },
              passingVariabel,
              (error, passingVariabel) => {
                consoleError('Error Download Update', error.response, passingVariabel);
              },
              (response, passingVariabel) => {
                consoleLog('Failed Download Update', response, passingVariabel);
              },
            );

            this.setState({
              indexDownload,
            });
            this._isDownloadUpdate = false;
            this._isRequestDownloadingUpdate = true;
          }
        }
        break;
      }
      default:
        break;
    }
  };

  cancelDownload = () => {
    const {dispatch} = this.props;
    dispatch(updateSystemAction.setSystemUpdatePending());

    const params = {};
    const passingVariabel = {};
    Post(
      APPDATA.API.CANCEL_DOWNLOAD_UPDATE,
      params,
      (response) => {
        response.data = {
          Status: 'Ok',
        };
        dispatch(updateSystemAction.setCancelDownloadBinaryUpdate(response.data));
        consoleLog('Success Cancel Download', response);
      },
      passingVariabel,
      (error) => {
        consoleError('Error Cancel Download', error.response);
      },
      (response) => {
        consoleLog('Failed Cancel Download', response);
      },
    );
  };

  getStatusUpdate = () => {
    const {dispatch} = this.props;
    dispatch(updateSystemAction.setSystemUpdatePending());
    const params = {};
    const passingVariabel = {};
    Get(
      APPDATA.API.STATUS_INSTALL_UPDATE,
      params,
      (response) => {
        dispatch(updateSystemAction.setStatusSystemUpdate(response.data));
        // consoleLog("Success Get Status Instal Update", response);
      },
      passingVariabel,
      (error) => {
        consoleError('Error Get Status Instal Update', error.response);
      },
      (response) => {
        consoleLog('Failed Get Status Instal Update', response);
      },
    );
  };

  tapScreenDownloadCheckVersion = () => {
    const text = APPDATA.MESSAGES.SOFTWARE_UPDATE.STOP_DOWNLOAD_VERSION;
    const question = APPDATA.MESSAGES.SOFTWARE_UPDATE.STOP_DOWNLOAD_QUESTION;
    const buttonEvent = this.onClickTapDownloadVersion;
    this.tapLoadingScreen(text, question, buttonEvent);
  };

  onClickTapDownloadVersion = (e) => {
    const {dispatch} = this.props;
    switch (e.currentTarget.id) {
      case APPDATA.CANCEL:
        consoleLog('onClickTapDownloadBinary Cancel', this._isDownloadUpdate);
        dispatch(loadingActions.updateLoading({showLoading: false}));
        break;
      case APPDATA.CONTINUE:
        break;
      default:
        break;
    }
    dispatch(modalActions.hidePopUp());
  };

  canclePreparingUpdate = () => {
    const {dispatch} = this.props;
    dispatch(loadingActions.updateLoading({showLoading: false}));
    if (this._isRequestDownloadingUpdate) this._isRequestDownloadingUpdate = false;
    if (this._isDownloadUpdate) {
      consoleLog('canclePreparingUpdate');
      this.cancelDownload();
      this._isRequestCancle = true;
    }
  };

  // need info any type of update
  // save to availableUpdate
  // [SOFTWARE,FIRMWARE,OPERATING_SYSTEM]
  downloadUpdate = (param) => {
    const {dispatch} = this.props;
    dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.PREPARING_DOWNLOAD_UPDATE,
        loadingClickEvent: undefined,
        loadingButton1: {
          label: APPDATA.CANCEL,
          onClick: this.canclePreparingUpdate,
        },
      }),
    );

    if (param.UpdateType === null) {
      dispatch(
        loadingActions.updateLoading({
          showLoading: true,
          loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.CHECK_INTERNET_CONNECTION,
          loadingClickEvent: this.tapScreenDownloadCheckVersion,
        }),
      );
      this._isRequestCheckVersion = true;
      this.checkVersion();

      consoleLog('UpdateType is null, now cheking system version');
      return;
    }
    const indexDownload = 0;
    const availabeUpdate = param.UpdateType.split(',');
    dispatch(updateSystemAction.setSystemUpdatePending());
    const param_ = {
      [APPDATA.KEY.DownloadType]: availabeUpdate[indexDownload],
    };
    const passingVariabel = param_;
    Post(
      APPDATA.API.DOWNLOAD_UPDATE,
      param_,
      (response, passingVariabel) => {
        dispatch(updateSystemAction.setDownloadBinaryUpdate(response.data));
        consoleLog('Success Download Update', response, passingVariabel);
      },
      passingVariabel,
      (error, passingVariabel) => {
        consoleError('Error Download Update', error.response, passingVariabel);
      },
      (response, passingVariabel) => {
        consoleLog('Failed Download Update', response, passingVariabel);
      },
    );

    this.setState({
      availabeUpdate,
      indexDownload,
    });
    this._isRequestDownloadingUpdate = true;
    if (this._isRequestCancle) this._isRequestCancle = false;
  };

  statusDownload = () => {
    const {dispatch} = this.props;
    dispatch(updateSystemAction.setSystemUpdatePending());
    const params = {};
    const passingVariabel = {};
    Get(
      APPDATA.API.STATUS_DOWNLOAD_UPDATE,
      params,
      (response) => {
        dispatch(updateSystemAction.setStatusDownloadBinaryUpdate(response.data));
        // consoleLog("Success Get Status Download Update", response);
        this.checkDownloadUpdateStatus(response.data);
      },
      passingVariabel,
      (error) => {
        consoleError('Error Get Status Download Update', error.response);
      },
      (response) => {
        consoleLog('Failed Get Status Download Update', response);
      },
    );
  };

  //---------------------------------------------------------------------------------------

  // needRestartModal = () => {
  //   const {dispatch} = this.props;
  //   const popUpButton = [
  //     {
  //       id: APPDATA.RESTART,
  //       isPrimaryButton: true,
  //       onClick: this.onClickRestartModal,
  //       label: APPDATA.RESTART,
  //     },
  //     {
  //       id: APPDATA.LATER,
  //       isPrimaryButton: false,
  //       onClick: this.onClickRestartModal,
  //       label: APPDATA.LATER,
  //     },
  //   ];
  //   dispatch(
  //     modalActions.showPopUp({
  //       popUpTitle: APPDATA.MESSAGES.SOFTWARE_UPDATE.MODAL_NEED_RESTART.TITLE,
  //       popUpText: APPDATA.MESSAGES.SOFTWARE_UPDATE.MODAL_NEED_RESTART.TEXT,
  //       popUpButton,
  //     }),
  //   );
  // };

  // onClickRestartModal = (e) => {
  //   const {dispatch} = this.props;
  //   // const {availabeUpdate} = this.state;
  //   // const UpdateName = [];
  //   // for (let i = 0; i < availabeUpdate.length; i++) {
  //   //   UpdateName.push({[APPDATA.KEY.UpdateOperations]: availabeUpdate[i]});
  //   // }
  //   const param = {
  //     // UpdateName,
  //     IsRestartRequired: true,
  //   };
  //   let passingVariabel = param;
  //   switch (e.currentTarget.id) {
  //     case APPDATA.RESTART:
  //       dispatch(
  //         loadingActions.updateLoading({
  //           showLoading: true,
  //           loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.PREPARING_INSTALL_UPDATE,
  //           loadingClickEvent: undefined,
  //         }),
  //       );
  //       dispatch(updateSystemAction.setSystemUpdatePending());
  //       param.IsRestartRequired = true;
  //       passingVariabel = param;
  //       Post(
  //         APPDATA.API.INSTALL_UPDATE,
  //         param,
  //         (response) => {
  //           dispatch(updateSystemAction.setInstallSystemUpdate(response.data));
  //         },
  //         passingVariabel,
  //         this.errorPostInstallUpdate,
  //         this.failedPostInstallUpdate,
  //       );
  //       break;
  //     case APPDATA.LATER:
  //       dispatch(updateSystemAction.isRestartLater(true));
  //       dispatch(updateSystemAction.setSystemUpdatePending());
  //       param.IsRestartRequired = false;
  //       passingVariabel = param;
  //       Post(
  //         APPDATA.API.INSTALL_UPDATE,
  //         param,
  //         this.successPostInstallUpdate,
  //         passingVariabel,
  //         this.errorPostInstallUpdate,
  //         this.failedPostInstallUpdate,
  //       );
  //       break;
  //     default:
  //       break;
  //   }
  //   dispatch(modalActions.hidePopUp());
  // };

  // successPostInstallUpdate = (response, passingVariabel) => {
  //   const {dispatch} = this.props;
  //   consoleLog('successPostInstallUpdate', {response, passingVariabel});
  //   if (response.data) {
  //     if (passingVariabel.IsRestartRequired) {
  //       dispatch(
  //         loadingActions.updateLoading({
  //           showLoading: true,
  //           loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.SHUTTING_DOWN,
  //           loadingClickEvent: undefined,
  //         }),
  //       );
  //     } else {
  //       dispatch(
  //         setupActions.showAlert({
  //           alertShow: true,
  //           alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.UPDATE_WHEN_RESTART,
  //           alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO,
  //         }),
  //       );
  //     }
  //   } else {
  //     dispatch(
  //       setupActions.showAlert({
  //         alertShow: true,
  //         alertText: APPDATA.MESSAGES.SOFTWARE_UPDATE.ALLERT.FAILED_UPDATE,
  //         alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
  //       }),
  //     );
  //   }
  // };

  // // eslint-disable-next-line class-methods-use-this
  // failedPostInstallUpdate = (response, passingVariabel) => {
  //   consoleLog('failedPostInstallUpdate', {response, passingVariabel});
  // };

  // // eslint-disable-next-line class-methods-use-this
  // errorPostInstallUpdate = (error, passingVariabel) => {
  //   consoleLog('errorPostInstallUpdate', {error, response: error.response, passingVariabel});
  // };

  //---------------------------------------------------------------------------------------
  checkVersion = () => {
    const {dispatch} = this.props;
    dispatch(updateSystemAction.setSystemUpdatePending());
    // const params = {};
    // const passingVariabel = {};

    postCheckVersionUpdateSW(true)
      .then((response) => {
        dispatch(updateSystemAction.setCheckVersionSystem(response.data));
        dispatch(loadingActions.updateLoading({showLoading: false}));
        consoleLog('Success Get Version', response);
      })
      .catch((error) => {
        consoleError('Error Get Version', error.response);
        dispatch(loadingActions.updateLoading({showLoading: false}));
      });
    // Post(
    //   APPDATA.API.CHECK_UPDATE_VERSION,
    //   params,
    //   (response) => {
    //     dispatch(updateSystemAction.setCheckVersionSystem(response.data));
    //     consoleLog('Success Get Version', response);
    //   },
    //   passingVariabel,
    //   (error) => {
    //     consoleError('Error Get Version', error.response);
    //     dispatch(loadingActions.updateLoading({showLoading: false}));
    //   },
    //   (response) => {
    //     consoleLog('Failed Get Version', response);
    //     dispatch(loadingActions.updateLoading({showLoading: false}));
    //   },
    // );
  };

  // getReleaseNotes = () => {
  //   const {dispatch} = this.props;
  //   dispatch(updateSystemAction.fetchSystemUpdatePending());
  //   const params = {};
  //   const passingVariabel = {};
  //   Get(
  //     APPDATA.API.RELEASE_NOTE,
  //     params,
  //     ( response) => {
  //       dispatch(updateSystemAction.fetchReleaseNotes(response.data));
  //       consoleLog('Success Get Release Notes', response);
  //     },
  //     passingVariabel,
  //     ( error) => {
  //       consoleError('Error Get Release Notes', error.response);
  //     },
  //     ( response) => {
  //       consoleLog('Failed Get Release Notes', response);
  //     },
  //   );
  // };

  render() {
    return null;
  }
}
export default UpdateSystem;

export const EventUpdateSystem = {
  DownloadBinaryUpdate: 'DownloadBinaryUpdate',
  InstallBinaryUpdate: 'InstallBinaryUpdate',
  CancleDownlaodBinary: 'CancleDownlaodBinary',
};
